import React, { ComponentType, useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectIsAuthorized } from '../../../redux/authSlice';
import paths from '../../paths';

interface IProps {
  children: React.ReactElement;
}

const PublicRoute = ({ component: Component }: { component: ComponentType }) => {
  const isAuthorized = useSelector(selectIsAuthorized);
  const navigate = useNavigate();

  useLayoutEffect(() => {
    if (isAuthorized) {
      navigate(paths.calculatorDashboard, { replace: true });
    }
  }, [isAuthorized, navigate]);

  return <Component />;
};


export default PublicRoute;
